"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { Button } from "@traqly/ui/components/button";
import { ArrowRightIcon } from "@traqly/ui/icons/arrow-icon";

import { checkClientViewPath } from "@lib/client-link/check-resource-access";

export const ErrorPageContent = () => {
  const path = usePathname();
  const isClientView = checkClientViewPath(path);

  if (isClientView) {
    return null;
  }

  return (
    <Link href="/dashboard">
      <Button
        variant="primary"
        size="lg"
      >
        Go to Home
        <ArrowRightIcon className="size-6" />
      </Button>
    </Link>
  );
};
